export default "__VITE_ASSET__DYL2z5oX__"